import React from 'react';
import { GAME_TYPES } from '../../constants/leaderboard';

const LeaderboardTabs = ({ activeGame, onChange }) => (
  <div className="leaderboard-tabs">
    {GAME_TYPES.map((g) => (
      <button
        key={g.key}
        className={`leaderboard-tab ${activeGame === g.key ? 'active' : ''}`}
        onClick={() => onChange(g.key)}
      >
        {g.label}
      </button>
    ))}
  </div>
);

export default React.memo(LeaderboardTabs);
